import { render } from "./QRCodeSettings.vue?vue&type=template&id=86bc9c80"
import script from "./QRCodeSettings.vue?vue&type=script&lang=js"
export * from "./QRCodeSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__